import React, { useContext } from "react";
import "./Loader.css";
import { LoaderContext } from "../../context/loader-context";

const Loader = ({...props }) => {
  const { cancelAllRequests } = useContext(LoaderContext);

  return (
    <>
        <button
          type="button"
          onClick={() => {cancelAllRequests()}}
          aria-label="Anuluj ładowanie"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 999999,
            width: "32px",
            height: "32px",
            border: "none",
            borderRadius: "50%",
            background: "#fff",
            color: "#333",
            fontSize: "24px",
            lineHeight: "32px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
            padding: 0,
          }}
        >
          ×
        </button>
      <div className="loading" {...props} />
    </>
  );
};

export default Loader;